import React from 'react'
import injectStyles from 'react-jss'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

import { styles } from './styles'

const BreadcrumbsBackButton = ({ classes, title }) => {
  const onBackToDocumentClick = () => {
    window.history.back()
  }

  return (
    <div className={classes.buttonContainer} onClick={onBackToDocumentClick}>
      <div className={classes.iconContainer}>
        <ArrowBackIcon />
      </div>
      <div className={classes.title}>{title}</div>
    </div>
  )
}

export default injectStyles(styles)(BreadcrumbsBackButton)
